<template>
    <div class='binding phoneStyle' :style="{'margin-top': $vuetify.breakpoint.mdAndDown ? '120px' : 0}">
        <!-- <a-spin :spinning="spinning" :tip="$t('spin.text')"> -->
            <div class="pwd-title">{{$t('login.retrieveEmail.title')}}</div>
            <v-form
              @submit.native.prevent
                v-model="valid"
                lazy-validation
                class="form-box"
                ref="retrieveForm"
            >
                <v-text-field
                    v-model="formData.phone"
                    outlined
                    hide-details="auto"
                    required
                    class="mb-8 input-h-md"
                    color="#5066e0"
                    :rules="bindingRules.phone"
                    :error-messages="phoneErrMsg"
                    :placeholder="$t('login.retrievePwd.phone')"
                ></v-text-field>

                <v-row no-gutters class="mb-8">
                    <v-col cols="8" md="8" lg="8" xl="8" sm="12 ">
                        <v-text-field
                            v-model="formData.phoneCode"
                            :rules="bindingRules.phoneCode"
                            outlined
                            hide-details="auto"
                            required
                            color="#5066e0"
                            class="code-box input-h-md"
                            :placeholder="$t('code.phoneCodePlaceholder')"
                        ></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3" md="3" lg="3" xl="3" sm="12" class="code-box  ml-1 d-flex justify-end align-baseline" :class="codeText == $t('code.get')?'cursor-pointer':'text'" @click="getCode">
                        <v-btn outlined v-if="codeText == $t('code.get')" color="primary" min-height="50" style="width:118%">{{codeText}}</v-btn>
                        <v-btn outlined v-else style="width:118%" disabled min-height="50">{{codeText+'s'}}</v-btn>
                    </v-col>
                </v-row>

                <v-text-field
                    v-model="formData.password"
                    :rules="bindingRules.password"
                    outlined
                    hide-details="auto"
                    required
                    color="#5066e0"
                    class="mb-8 input-h-md"
                    :error-messages="errorMessage"
                    :type="isPasswordVisible1 ? 'text' : 'password'"
                    :append-icon="isPasswordVisible1 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                    @click:append="isPasswordVisible1 = !isPasswordVisible1"
                    :placeholder="$t('login.retrieveEmail.password')"
                ></v-text-field>

                <v-text-field
                    v-model="formData.affirmPassword"
                    :rules="bindingRules.affirmPassword"
                    outlined
                    hide-details="auto"
                    required
                    color="#5066e0"
                    class="mb-8 input-h-md"
                    :type="isPasswordVisible2 ? 'text' : 'password'"
                    :append-icon="isPasswordVisible2 ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                    @click:append="isPasswordVisible2 = !isPasswordVisible2"
                    :placeholder="$t('login.retrieveEmail.affirmPassword')"
                ></v-text-field>

                <v-btn type="primary" :style="{backgroundColor:'#004CA0'}" min-height="50" class="btn-box" @click="onSubmit">{{$t('btn.submit')}}</v-btn>
                <div class="tip-box">
                    <div class="tip" @click="goBack">
                        <v-icon size="22"> {{ icons.mdiArrowLeft}} </v-icon>
                        {{$t('login.retrieveEmail.back')}}</div>
                    <div class="tip tip-r" ></div>
                </div>
            </v-form>
        <!-- </a-spin> -->
    </div>
</template>

<script>
import { resetPwd, sendSms } from "@/api/index";
import { mdiEyeOutline, mdiEyeOffOutline, mdiArrowLeft } from '@mdi/js';
import store from '@/store'

let self
export default {
    data() {
        let validatePass2 = (value) => {
            if (value === '') {
                return this.$t('login.retrieveEmail.affirmPasswordss')
            } else if (value !== this.formData.password) {
                return this.$t('login.retrieveEmail.verifyPassword')
            } else {
                return true
            }
        };
        return {
            formData: {},
            bindingRules: {
                phone: [
                    v => !!v || this.$t('login.retrievePwd.phone'),
                    // v => (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$/.test(v)) || this.$t('login.retrievePwd.phoneErr'),
                ],
                password: [
                    v => !!v || this.$t('login.retrieveEmail.newPwd')
                ],
                phoneCode: [
                    v => !!v || this.$t('code.phoneCodePlaceholder'),
                    v => (/^[0-9]{6}$/.test(v)) || this.$t('code.msg6')
                ],
                affirmPassword: [
                    v => !!v || this.$t('login.retrieveEmail.affirmMsg'),
                    v => validatePass2(v)
                ],
            },
            codeText: this.$t('code.get'),
            valid: true,
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline,
                mdiArrowLeft
            },
            isPasswordVisible1: false,
            isPasswordVisible2: false,
            errorMessage: undefined,
            phoneErrMsg: undefined,
            // spinning: false
        };
    },
    props: {
        bindToken: String
    },
    created() {
        self = this
    },
    watch: {
        'formData.password': (val,old) => {
            if(val) {
                self.validatePass(val)
            }
        },
        'formData.phone': (val,old) => {
            self.phoneErrFun(val)
        }
    },
    methods: {
        onSubmit() {
            if (this.$refs.retrieveForm.validate()) {
                this.$passwordEncryption(this.formData.password).then(password=> {
                    let params = {
                        password: password,
                        phonesn: this.formData.phone,
                        phoneCode: this.formData.phoneCode
                    }
                    resetPwd(params).then(res=> {
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            this.$emit("goBack")
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    })
                })
            } else {
                return false
            }
        },
        getCode() {
            this.phoneErrFun(this.formData.phone)
            if(this.phoneErrMsg != undefined) {
                return
            }
            // if(this.$refs.retrieveForm.fields[0])
            if (this.formData.phone && this.codeText == this.$t('code.get')) {
                // this.spinning = true
                let params = {
                    phonesn: this.formData.phone,
                    smsType: this.$getSmsModel('retrievePwd')
                }
                sendSms(params).then(res=>{
                    // this.spinning = false
                    if (res.code == this.$GLOBA.StatusOK) {
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'success'
                        })
                        if(this.codeText == this.$t('code.get')) {
                            this.codeText = 60
                            let timer = setInterval(()=>{
                                this.codeText--
                                if(this.codeText <= 0) {
                                    clearInterval(timer)
                                    this.codeText = this.$t('code.get')
                                }
                            },1000)
                        }
                    }else{
                        store.dispatch('snackbar/openSnackbar',{
                            snackbarText: res.message,
                            colorType: 'error'
                        })
                    }
                }).catch(err=> {
                    // this.spinning = false
                })
            }
        },
        goBack() {
            this.$emit("goBack")
        },
        goEmail() {
           this.$emit("goEmail")
        },
        validatePass(value) {
            this.$checkNotLoginPassword(value,this.formData.phone,0).then(res => {
                this.errorMessage = res
            })
        },
        phoneErrFun(v) {
            if (!v) {
                this.phoneErrMsg = this.$t('login.retrievePwd.phone')
            } else if (!(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(v))) {

                this.phoneErrMsg = this.$t('login.retrievePwd.phoneErr')
            } else {
                this.phoneErrMsg = undefined
            }
        }
    },
}
</script>

<style lang='scss' scoped>
.binding {
    // flex: 1;
    width: 365px;
    // padding-top:8%;
    // margin-left: 250px;
    z-index: 15;
    .form-box ::v-deep {
        padding: 50px 0;
        .ant-form-item {
            margin-bottom: 30px;
        }
        .ant-input {
            font-size: 16px;
            height: 46px;
            border-radius: 10px;
            padding-left: 20px;
            // background-color: #F5F5F5;
            // border: none;
        }
        .ant-input:focus {
            box-shadow:none;
        }
        .btn-box {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background: #5066e0;
            box-shadow: 0px 0px 10px 1px rgba(0, 80, 179, 0.2);
            // border-radius: 10px;
            font-size: 16px;
            font-weight: 500;
            color: #FFFEFE;
            margin-top: 10px;
        }
    }
    .ant-input-password ::v-deep {
        .ant-input-suffix {
            right: 20px;
        }
    }
}
.pwd-title {
    height: 70px;
    line-height: 70px;
    // padding-left: 95px;
    // border-bottom: 1px solid rgba(0,0,0,.12);
    font-size: 32px;
    font-weight: 500;
    text-align: center;
}
.tip-box {
    display: flex;
    .tip {
        // flex: 1;
        font-size: 16px;
        margin-top: 20px;
        font-weight: 500;
        color: #5066e0;
        cursor: pointer;
    }
    .tip-r {
        text-align: right;
        flex: 1;
    }
}
.code-box ::v-deep {
    .ant-form-item-children {
        display: flex;
    }
    .code-btn {
        flex: 1;
    }
    .get-code {
        cursor: pointer;
        width: 120px;
        height: 46px;
        line-height: 46px;
        background:#004CA0;
        border-radius: 10px;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        margin-left: 20px;
    }
}
@media screen and (min-width: 320px) and (max-width: 480px){
        .phoneStyle {
            paddind : 0px 10px 0px 10px !important;
        }
        .binding{
            min-width: 341px;
            padding: 0px 10px 0px 10px !important;

        }
        .v-btn.v-size--default{
            font-size: 14px;
        }
        ::v-deep {
            .v-text-field.v-text-field--enclosed .v-text-field__details{
                padding: 0;
            }
        }
}
</style>
